<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [plotOptions]="chartOptions.plotOptions!"
        [labels]="chartOptions.labels!"
        [colors]="chartOptions.colors!"
    ></apx-chart>
</div>